import React, { useEffect, useState } from "react";
import firebase from "./firebase";
import Map from "./Map";
import { CurrentPosition, Store } from "./types";

export default function ListNearby(props: CurrentPosition) {
  const [tileData, setTileData] = useState<Store[]>([]);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (props.geohash === "") return;

    const db = firebase.firestore();
    let list: { [storeId: string]: Store } = {};
    db.collection("store")
      .orderBy("geohash")
      .startAt(props.geohash.substring(0, 5))
      .endAt(props.geohash.substring(0, 5) + "\uf8ff")
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let createdTime = new Date();
          const gotTime = doc.data().createdTime;
          if (gotTime) {
            createdTime = doc.data().createdTime.toDate();
          }
          const storeData = {
            ...doc.data(),
            createdTime,
          } as Store;

          // TODO: migration
          if (!storeData.storeId || storeData.storeId === "") {
            storeData.storeId = storeData.id;
          }

          if (list[storeData.storeId]) {
            if (list[storeData.storeId].createdTime > storeData.createdTime) {
              list[storeData.storeId].images.push(...storeData.images);
            } else {
              storeData.images.push(...list[storeData.storeId].images);
              list[storeData.storeId] = storeData;
            }
          } else {
            list[storeData.storeId] = storeData;
          }
        });
        setTileData(Object.values(list));
        setFetching(false);
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);
      });
  }, [props.geohash]);

  if (fetching) {
    return <div />;
  }
  return <Map position={props} tileData={tileData}></Map>;
}
